


































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { AddToShoppingCartIcon } from '@/components/icons/AddToShoppingCartIcon';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import { ShoppingCartModuleTypes } from '@/store/modules/shopping-cart';
import { PartAnalytics } from '@/entities/analytics/PartAnalytics';
import DeliveryTimeToolTip from '@/components/delivery-time-tooltip/DeliveryTimeToolTip.vue';
import BaseMixin from '@/mixins/BaseMixin';
import { PartAvailability } from '@/entities/PartAvailability';
import { PartService } from '@/services/part-service';
import _ from 'lodash';

@Component({
    components: {
        LoadingIndicator,
        AddToShoppingCartIcon,
        DeliveryTimeToolTip,
    },
})
export default class PartDetailsActions extends Mixins(BaseMixin) {
    @Prop({ type: String, required: true })
    private fullPartId!: string;
    @Prop({ type: String, required: true })
    private partNumber!: string;
    @Prop({ type: String, required: true })
    private brandCode!: string;
    @Prop({ type: String })
    private unitCode!: string;
    @Prop({ type: Boolean, default: false })
    private isNotInStockButReplaceable!: boolean;
    @Prop({ type: Boolean, default: false })
    private isUsedPart!: boolean;

    private currentQuantity: number = 1;
    private quantityHasFocus: boolean = false;
    private partAvailability: PartAvailability | null = null;
    private isLoadingAvailability: boolean = false;
    private partService: PartService = new PartService();
    private reloadAvailabilityDebounced: (quantity: number) => Promise<void> | undefined;

    constructor() {
        super();
        this.reloadAvailabilityDebounced = _.debounce(this.reloadAvailability, 500);
    }

    // called by vue
    public created(): void {
        this.reloadAvailability(this.currentQuantity);
    }

    public get isQuantityValid(): boolean {
        if (!this.isUsedPart) {
            return this.currentQuantity > 0;
        }

        return this.partAvailability !== null && this.currentQuantity > 0 && this.currentQuantity <= this.getAvailableItemCount();
    }

    public get hasActiveShoppingCart(): boolean {
        return this.$store.getters[ShoppingCartModuleTypes.getters.hasActiveShoppingCart];
    }

    public get isItemCurrentlyBeingAdded(): boolean {
        return this.$store.getters[ShoppingCartModuleTypes.getters.isItemCurrentlyBeingAdded](this.fullPartId);
    }

    private async onAddItemToShoppingCart(): Promise<void> {
        await this.$store.dispatch(ShoppingCartModuleTypes.actions.addShoppingCartItem, {
            fullPartId: this.fullPartId,
            partNumber: this.partNumber,
            quantity: this.currentQuantity,
        });
        this.currentQuantity = 1;
        this.reloadAvailability(this.currentQuantity);
    }

    private quantityChanged(): void {
        if (this.isQuantityValid && this.quantityHasFocus) {
            this.reloadAvailabilityDebounced(this.currentQuantity);
        }
    }

    private quantityFocusStateChanged(hasFocus: boolean): void {
        this.quantityHasFocus = hasFocus;
    }

    private async reloadAvailability(quantity: number): Promise<void> {
        this.isLoadingAvailability = true;
        try {
            const availability = await this.partService.getAvailabilityOfPart(
                this.fullPartId,
                quantity,
                undefined,
                true
            );
            this.partAvailability = availability;
        } catch {
            this.partAvailability = null;
        } finally {
            this.isLoadingAvailability = false;
        }
    }

    private getAvailableItemCount(): number {
        if (!this.partAvailability || !this.partAvailability.stockInfos) {
            return 0;
        }
        return this.partAvailability.stockInfos
            .map((info) => info.quantity)
            .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    }
}
